const constants = require('@/util/constants')
require('./config')

/**
 * 分页获取拉黑访客
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getBlocks (page, size, successcb, failedcb) {
  axios.get('/api/block/get', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 添加黑名单
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function addBlock (uid, note, successcb, failedcb) {
//   axios.post('/api/block/add', {
//     uid,
//     note,
//     client: constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 添加黑名单
 * @param {*} uid 被拉黑用户uid
 * @param {*} note 备注
 * @param {*} type 会话类型
 * @param {*} uuid 唯一id：客服uid 或 技能组wid
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function addBlock(uid, note, type, uuid, successcb, failedcb) {
  axios.post('/api/block/add2', {
    uid,
    note,
    type,
    uuid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 取消黑名单
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function removeBlock (bid, successcb, failedcb) {
  axios.post('/api/block/remove', {
    bid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索黑名单
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function searchBlock(content, page, size, successcb, failedcb) {
  axios.get('/api/block/search', {
    params: {
      'content': content,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
